<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(rowData)">
        <span>{{ checkStatus(rowData) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        chipColor() {
            return value => {
                if (value.status == 1) {
                    return "pending"
                } else if (value.status == 2) {
                    return "success"
                } else if (value.status == 3) {
                    return "complete"
                } else if (value.status == 4) {
                    return "danger"
                }
            }
        },
        checkStatus() {
            return value => {
                if (value.status == 1) {
                    return 'Chờ xử lý'
                } else if (value.status == 2) {
                    return 'Đã xác nhận'
                } else if (value.status == 3) {
                    return 'Đã hoàn thành'
                } else if (value.status == 4) {
                    return 'Hủy'
                }
            }
        }
    }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .2);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .2);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .2);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-pending {
        background: rgb(143, 143, 143, .2) !important;
        color: rgb(143, 143, 143) !important;
        font-weight: 500;
    }

    &.vs-chip-complete {
        background: rgba(157, 101, 201, .2) !important;
        color: rgb(157, 101, 201) !important;
        font-weight: 500;
    }
}
</style>
